import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import SplitPane from "react-split-pane";
import InsertCompanyLogo from "./InsertCompanyLogo";
import InsertHeaderDetails from "./InsertHeaderDetails";
import InsertFooterDetails from "./InsertFooterDetails";

const ReportMetadata = () => {
  const [type, setType] = useState("logo");
  return (
    <div>
      <SplitPane
        split="vertical"
        className="position-relative"
        style={{ height: "calc(100vh - 145px)" }}
        defaultSize={"15%"}
      >
        <div>
          <section className="middle-content">
            <div className="client-collapse">
              <div className="card card-body">
                <NavLink className={type === "logo" && "selectedMenu"} onClick={() => setType("logo")}>Logo</NavLink>
                <NavLink className={type === "header" && "selectedMenu"} onClick={() => setType("header")}>Header</NavLink>
                <NavLink className={type === "footer" && "selectedMenu"} onClick={() => setType("footer")}>Footer</NavLink>
              </div>
            </div>
          </section>
        </div>
        {type === "logo" ? (
          <InsertCompanyLogo type="logo" />
        ) : type === "header" ? (
          <InsertHeaderDetails type="header"/>
        ) : type === "footer" ? (
          <InsertFooterDetails type="footer"/>
        ) : (
          ""
        )}
      </SplitPane>
    </div>
  );
};

export default ReportMetadata;
